<template>
  <div class="industry_module">
    <el-tabs v-model="activeName">
      <!-- {{$attrs}} -->
      <el-tab-pane label="Search results" name="first">
        <industry-tab1 :lists="$attrs.lists" :total="$attrs.total" v-on="$listeners"></industry-tab1>
      </el-tab-pane>
      <el-tab-pane label="Index search" name="second">
        <industry-tab2></industry-tab2>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import IndustryTab1 from "./industryTab1";
import IndustryTab2 from "./industryTab2";

export default {
  props: {},

  components: {
    IndustryTab1,
    IndustryTab2
  },

  data() {
    return {
      activeName: "first"
    };
  },

  created() {},

  methods: {
    industrySearch(key, value) {
      this.$emit("search", "industry", data);
    }
  }
};
</script>

<style scoped>
.industry_module {
  height: 100%;
}
.industry_module >>> .el-tabs,
.industry_module >>> .el-tabs__content,
.industry_module >>> .el-tab-pane {
  height: 100% !important;
}
.industry_module >>> .el-tabs__content {
  height: 100% !important;
}
.industry_module >>> .el-tabs__nav-wrap::after {
  width: 0px !important;
}
.industry_module >>> .el-tabs__nav {
  width: 100% !important;
  background: #f7f8fa !important;
}
.industry_module >>> .el-tabs__nav .el-tabs__item {
  width: 50% !important;
  text-align: center;
}
.industry_module >>> .el-tabs__nav .is-active {
  background: #e2f0ff !important;
  color: #000000 !important;
  border-top: 2px solid #0078ff;
}
.industry_module >>> .el-tabs__active-bar {
  height: 0px !important;
}
</style>